import { Injectable } from '@angular/core'
import { HttpHelper,
  IEntityMappingConfig,
  Utils,
  AppContext
} from '../../..'
import { UriFactory } from '../../../core/factories'
import { ModelFactory } from '../../../data/factories'
import { JsonApiOperationRequest, JsonApiProcessor } from '../../../data/services'
import {
  ModelMapper,
  EntityMappingManager,
  ModelIdentityMap,
  EntityMappingFactory,
  Store,
  JsonapiUrlGenerator
} from '../../'

@Injectable()
export class JsonApiProcessorBuilder {

  private _modelMapper: ModelMapper
  private _entityMappingManager: EntityMappingManager
  private _modelIdentityMap: ModelIdentityMap

  constructor(
    private _apiRoot: string,
    private _appContext: AppContext,
    private _modelClasses: any[],
    private _endpointMapping: { [className: string]: string },
    private _entityMappingConfigs: IEntityMappingConfig[],
    private _uriFactory: UriFactory,
    private _httpHelper: HttpHelper,
    private _utils: Utils,
    private _entityMappingFactory: EntityMappingFactory
  ) {
    this._validateEntityParameters()
  }

  public setModelIdentityMap(idMap: ModelIdentityMap) {
    this._modelIdentityMap = idMap
    return this
  }

  public build() {
    return new JsonApiProcessor(
      this._httpHelper,
      this._createStore(),
      this._createOrGetModelMapper(),
      this._utils,
      this._createOperationRequest()
    )
  }

  private _validateEntityParameters() {
    const countModelClasses = this._modelClasses.length
    const countEndpointMappings = Object.keys(this._endpointMapping).length

    if (countEndpointMappings !== countModelClasses) {
      throw new Error('Not all model classes have a configured endpoint!')
    }
  }

  private _createOrGetModelMapper(): ModelMapper {
    return this._modelMapper || new ModelMapper(
      this._createOrGetModelIdentityMap(),
      this._createModelFactory(),
      this._createOrGetEntityMappingManager(),
      this._utils
    )
  }
  private _createStore(): Store {
    return new Store()
  }

  private _createOrGetEntityMappingManager() {
    return this._entityMappingManager ||
      new EntityMappingManager(
        this._entityMappingConfigs,
        this._entityMappingFactory,
        this._utils
      )
  }

  private _createModelFactory(): ModelFactory {
    return new ModelFactory(this._modelClasses, this._utils)
  }

  private _createOrGetModelIdentityMap(): ModelIdentityMap {
    return this._modelIdentityMap || new ModelIdentityMap()
  }

  private _createOperationRequest(): JsonApiOperationRequest {
    return new JsonApiOperationRequest(
      this._utils,
      this._createJsonApiUrlGenerator(),
      this._createOrGetModelMapper(),
      this._uriFactory
    )
  }

  private _createJsonApiUrlGenerator(): JsonapiUrlGenerator {
    return new JsonapiUrlGenerator(
      this._apiRoot,
      this._endpointMapping,
      this._createOrGetEntityMappingManager(),
      this._appContext
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/model-repository/creators/json-api-processor-builder/json-api-processor.builder.ts